export default "__VITE_ASSET__Dree6OiC__"